/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  INVITE_USER: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.klefki.studentsBatch.createGroup',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'CREATE_GROUP' },
      },
    },
    CREATE_GROUP: {
      invoke: {
        id: 'createGroup',
        src: 'createGroup',
        onDone: {
          target: 'CREATE_GROUP_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'CREATE_GROUP_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    CREATE_GROUP_SUCCESS: {
      on: {
        START: { target: 'CREATE_GROUP' },
      },
    },
    CREATE_GROUP_FAILED: {
      on: {
        START: { target: 'CREATE_GROUP' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
